import { Box, Chip, Typography } from "@mui/material";
import React from "react";

interface Item {
  id: number;
  value: string;
  isAggregate: boolean;
}

export default function ChipsWithAggregation({
  items,
  value = [],
  onChange,
  error,
  helperText,
  disabled,
}: {
  items: Item[];
  value: number[];
  onChange: (value: number[]) => void;
  error: boolean;
  helperText: string | undefined;
  disabled?: boolean;
}) {
  return (
    <Box>
      <Box mt={1} display="flex" flexWrap="wrap">
        {items.map((item) => (
          <Box pr={1} pb={1}>
            <Chip
              disabled={disabled}
              label={item?.value}
              variant={
                value?.includes(items.filter((i) => i.isAggregate)?.[0]?.id)
                  ? "filled"
                  : value?.includes(item?.id)
                  ? "filled"
                  : "outlined"
              }
              color="primary"
              clickable
              onClick={() => {
                if (item?.isAggregate) {
                  let allItemValue = items.filter((i) => i.isAggregate);
                  onChange([allItemValue?.[0]?.id]);
                  if (
                    value?.includes(items.filter((i) => i.isAggregate)?.[0]?.id)
                  ) {
                    onChange([]);
                  }
                } else {
                  if (
                    value?.includes(items.filter((i) => i.isAggregate)?.[0]?.id)
                  ) {
                    onChange([item?.id]);
                  } else {
                    if (value?.includes(item?.id)) {
                      let updatedValues = value?.filter((i) => i !== item?.id);
                      onChange(updatedValues);
                    } else {
                      value?.push(item?.id);
                      onChange([...value]);
                    }
                  }
                }
                if (items?.length - 1 === value?.length) {
                  let allItemValue = items.filter((i) => i.isAggregate);
                  onChange([allItemValue?.[0]?.id]);
                }
              }}
            ></Chip>
          </Box>
        ))}
      </Box>
      {error && (
        <Typography variant="caption" color="error">
          {helperText}
        </Typography>
      )}
    </Box>
  );
}
